// extracted by mini-css-extract-plugin
export default {"skillItem":"SkillsItem_skillItem__SumCQ"};